import { webappDetail, webappSelect } from "@/js/appDetail"
import axios from 'axios'

const TIANDITU_KEY = 'b36044c234f59e3025437e864c934f89';

function getAddressByLngLat(lng, lat, callback) {
  var postStr = JSON.stringify({
    lon: lng,
    lat: lat,
    ver: 1
  });
  var url = `https://api.tianditu.gov.cn/geocoder?postStr=${encodeURIComponent(postStr)}&type=geocode&tk=${TIANDITU_KEY}`;
  
  axios.get(url)
    .then(function(response) {
      if (response.data && response.data.status == 0 && response.data.result) {
        callback(response.data.result.formatted_address || "");
      } else {
        callback("");
      }
    })
    .catch(function() {
      callback("");
    });
}

function getSiteMapAddress(list) {
  var result = [];
  if (!list || list.length < 1) return result;
  var datas = Object.assign([], list);
  var addressName = 'Address';
  var detailName = 'Detail';
  datas.forEach(el => {
    var str = {
      id: el.id,
      longitude: el.longitude,
      latitude: el.latitude,
      name: el.name,
      role: el.role,
      system_id: el.system_id,
      websocket_address: el.websocket_address,
      battery_voltage_type: el.battery_voltage_type,
      timeZone: el.timeZone,
      location: el.location,
      status: el.alarm_status,
      online: el.online,
      content: `<h5 class="map-title">${el.name}</h5>` +
        `<p class="map-info">${addressName}：${el.location}
            <a class="map-link" data-tz='${JSON.stringify(el.timeZone)}' data-bt="${el.battery_voltage_type}" data-web="${el.websocket_address}" data-id="${el.id}" data-role="${el.role}" data-sys="${el.system_id}"  id="detail${el.id}" href="javascript:;">${detailName}</a>
        </p>`
    }
    result.push(str)
  });
  return result;
}

export function initMarker(data) {
  let pt = new TMap.LatLng(parseFloat(data.latitude), parseFloat(data.longitude));
  let iconUrl = "";
  if (!data.online) {
    iconUrl = require("../assets/images/map_offline.png");
  } else {
    if (data.status == 2) {
      iconUrl = require("../assets/images/map_alarm.png");
    } else {
      iconUrl = require("../assets/images/map_green.png");
    }
  }
  return {
    id: data.id,
    position: pt,
    icon: {
      url: iconUrl,
      size: new TMap.Point(30, 30),
      anchor: new TMap.Point(15, 15)
    }
  }
}

export function initInfoWindow(data) {
  let str = data.content;
  return new TMap.InfoWindow({
    content: str,
    offset: {
      x: 0,
      y: -10
    }
  });
}

export function initBMap2(list, that) {
  if (!list || list.length < 1) return;
  if (that.map) {
    that.map = null;
  }

  var centerLat = 24.484769;
  var centerLng = 118.13271;

  that.map = new TMap.Map("siteMaps", {
    center: new TMap.LatLng(centerLat, centerLng),
    zoom: 12
  });

  var ll = getSiteMapAddress(list);
  if (ll.length < 1) return;

  var geometries = ll.map(function(opt) {
    let iconUrl = opt.online ? (opt.status == 2 ? require("../assets/images/map_alarm.png") : require("../assets/images/map_green.png")) : require("../assets/images/map_offline.png");
    return {
      id: opt.id,
      position: new TMap.LatLng(opt.latitude, opt.longitude),
      icon: {
        url: iconUrl,
        size: new TMap.Point(30, 30),
        anchor: new TMap.Point(15, 15)
      }
    };
  });

  var markerLayer = new TMap.MultiMarker({
    map: that.map,
    geometries: geometries
  });

  var infoWindow = new TMap.InfoWindow();
  markerLayer.on('click', function(e) {
    var targetId = e.detail.geometry.id;
    var opt = ll.find(function(item) {
      return item.id == targetId;
    });
    if (opt) {
      infoWindow.setContent(opt.content);
      infoWindow.open(that.map, e.detail.latLng);
    }
  });

  infoWindow.on('open', function() {
    ll.forEach(function(opt) {
      if (document.getElementById("detail" + opt.id)) {
        document.getElementById("detail" + opt.id).onclick = function(e) {
          var id = this.getAttribute('data-id');
          webappDetail(id);
        }
      }
    });
  });

  var bounds = new TMap.LatLngBounds();
  geometries.forEach(function(geo) {
    bounds.extend(geo.position);
  });
  that.map.fitBounds(bounds);
}

export function initGoogleMap2(list, that) {
  if (!list || list.length < 1) return;
  if (that.googleMap) {
    that.googleMap = null;
  }

  var centerLat = 24.485821;
  var centerLng = 118.095915;

  if (that.longitude && that.latitude) {
    centerLat = parseFloat(that.latitude);
    centerLng = parseFloat(that.longitude);
  }

  that.googleMap = new TMap.Map("siteMaps", {
    center: new TMap.LatLng(centerLat, centerLng),
    zoom: 10
  });

  var infoWindow = new TMap.InfoWindow();

  if (that.longitude && that.latitude) {
    var markerLayer = new TMap.MultiMarker({
      map: that.googleMap,
      geometries: [{
        id: "marker",
        position: new TMap.LatLng(that.latitude, that.longitude)
      }]
    });

    infoWindow.setContent(that.latitude + ",</br>" + that.longitude);
    infoWindow.open(that.googleMap, new TMap.LatLng(that.latitude, that.longitude));
  } else {
    var markerList = getSiteMapAddress(list);
    if (!markerList || markerList.length < 1) return;

    var geometries = markerList.map(function(item) {
      return {
        id: item.id,
        position: new TMap.LatLng(item.latitude, item.longitude)
      };
    });

    var markerLayer = new TMap.MultiMarker({
      map: that.googleMap,
      geometries: geometries
    });

    var bounds = new TMap.LatLngBounds();
    geometries.forEach(function(geo) {
      bounds.extend(geo.position);
    });
    that.googleMap.fitBounds(bounds);

    markerLayer.on('click', function(e) {
      var targetId = e.detail.geometry.id;
      var item = markerList.find(function(m) {
        return m.id == targetId;
      });
      if (item) {
        infoWindow.setContent(item.content);
        infoWindow.open(that.googleMap, e.detail.latLng);
      }
    });

    infoWindow.on('open', function() {
      markerList.forEach(function(item) {
        if (document.getElementById("detail" + item.id)) {
          document.getElementById("detail" + item.id).onclick = function(e) {
            var id = this.getAttribute('data-id');
            webappDetail(id);
          }
        }
      });
    });
  }
}

export function initBMap(that){
  if (that.map) {
    that.map = null;
  }

  var centerLat = 24.484769;
  var centerLng = 118.13271;
  var marker = null;

  if (that.lon && that.lon != "0" && that.lat && that.lat != "0") {
    centerLat = parseFloat(that.lat);
    centerLng = parseFloat(that.lon);
    that.longitude = that.lon;
    that.latitude = that.lat;
  }

  that.map = new T.Map("siteMaps", {
    center: new T.LngLat(centerLng, centerLat),
    zoom: 12
  });

  if (that.longitude && that.latitude) {
    marker = new T.Marker(new T.LngLat(that.longitude, that.latitude));
    that.map.addOverLay(marker);

    getAddressByLngLat(that.longitude, that.latitude, function(address) {
      that.location = address;
      console.log({
        latitude: that.latitude.toString(),
        longitude: that.longitude.toString(),
        location: that.location
      });
      webappSelect(JSON.stringify({
        latitude: that.latitude.toString(),
        longitude: that.longitude.toString(),
        location: that.location || ""
      }));
    });
  }

  that.map.addEventListener("click", function(e) {
    var latLng = e.lnglat;
    if (!latLng) {
      return;
    }

    var lng = latLng.getLng();
    var lat = latLng.getLat();

    that.longitude = Number(lng).toFixed(6);
    that.latitude = Number(lat).toFixed(6);

    if (marker) {
      that.map.removeOverLay(marker);
    }
    marker = new T.Marker(new T.LngLat(lng, lat));
    that.map.addOverLay(marker);

    getAddressByLngLat(lng, lat, function(address) {
      that.location = address;
      console.log({
        latitude: that.latitude.toString(),
        longitude: that.longitude.toString(),
        location: that.location
      });
      webappSelect(JSON.stringify({
        latitude: that.latitude.toString(),
        longitude: that.longitude.toString(),
        location: that.location || ""
      }));
    });
  });
}

export function initGoogleMap(that){
  if (that.googleMap) {
    that.googleMap = null;
  }

  var centerLat = 24.484769;
  var centerLng = 118.13271;
  var marker = null;

  if (that.lon && that.lon != "0" && that.lat && that.lat != "0") {
    centerLat = parseFloat(that.lat);
    centerLng = parseFloat(that.lon);
  }

  that.googleMap = new google.maps.Map(document.getElementById("siteMaps"), {
    zoom: 10,
    center: {
      lat: centerLat,
      lng: centerLng
    },
    zoomControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false
  });

  if (that.lon && that.lon != "0" && that.lat && that.lat != "0") {
    that.latitude = Number(centerLat).toFixed(6);
    that.longitude = Number(centerLng).toFixed(6);

    marker = new google.maps.Marker({
      position: {
        lat: centerLat,
        lng: centerLng
      },
      map: that.googleMap
    });

    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({
      location: {
        lat: centerLat,
        lng: centerLng
      }
    }, function(results, status) {
      if (status === 'OK' && results[0]) {
        that.location = results[0].formatted_address;
      } else {
        that.location = "";
      }
      console.log({
        latitude: that.lat,
        longitude: that.lon,
        location: that.location
      });
      webappSelect(JSON.stringify({
        latitude: that.lat,
        longitude: that.lon,
        location: that.location || ""
      }));
    });
  }

  that.googleMap.addListener("click", function(e) {
    var lat = e.latLng.lat();
    var lng = e.latLng.lng();

    that.latitude = Number(lat).toFixed(6);
    that.longitude = Number(lng).toFixed(6);

    if (marker) {
      marker.setMap(null);
    }
    marker = new google.maps.Marker({
      position: {
        lat: lat,
        lng: lng
      },
      map: that.googleMap
    });

    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({
      location: {
        lat: lat,
        lng: lng
      }
    }, function(results, status) {
      if (status === 'OK' && results[0]) {
        that.location = results[0].formatted_address;
      } else {
        that.location = "";
      }
      console.log({
        latitude: that.latitude,
        longitude: that.longitude,
        location: that.location
      });
      webappSelect(JSON.stringify({
        latitude: that.latitude,
        longitude: that.longitude,
        location: that.location || ""
      }));
    });
  });
}

export function initBMapTest(that){
  if (that.map) {
    that.map = null;
  }

  var centerLat = 24.484769;
  var centerLng = 118.13271;
  var marker = null;

  if (that.lon && that.lon != "0" && that.lat && that.lat != "0") {
    centerLat = parseFloat(that.lat);
    centerLng = parseFloat(that.lon);
    that.longitude = that.lon;
    that.latitude = that.lat;
  }

  that.map = new T.Map("siteMaps", {
    center: new T.LngLat(centerLng, centerLat),
    zoom: 12
  });

  if (that.longitude && that.latitude) {
    marker = new T.Marker(new T.LngLat(that.longitude, that.latitude));
    that.map.addOverLay(marker);

    getAddressByLngLat(that.longitude, that.latitude, function(address) {
      that.location = address;
      console.log({
        latitude: that.latitude.toString(),
        longitude: that.longitude.toString(),
        location: that.location
      });
      webappSelect(JSON.stringify({
        latitude: that.latitude.toString(),
        longitude: that.longitude.toString(),
        location: that.location || ""
      }));
    });
  }

  that.map.addEventListener("click", function(e) {
    var latLng = e.lnglat;
    if (!latLng) {
      return;
    }

    var lng = latLng.getLng();
    var lat = latLng.getLat();

    that.longitude = Number(lng).toFixed(6);
    that.latitude = Number(lat).toFixed(6);

    if (marker) {
      that.map.removeOverLay(marker);
    }
    marker = new T.Marker(new T.LngLat(lng, lat));
    that.map.addOverLay(marker);

    getAddressByLngLat(lng, lat, function(address) {
      that.location = address;
      console.log({
        latitude: that.latitude.toString(),
        longitude: that.longitude.toString(),
        location: that.location
      });
      webappSelect(JSON.stringify({
        latitude: that.latitude.toString(),
        longitude: that.longitude.toString(),
        location: that.location || ""
      }));
    });
  });
}